<template>
  <div class="auth-container">
    Waiting...
  </div>
</template>

<script>
export default {
  name: 'Auth',
  metaInfo: {
    title: 'Market Moves',
    titleTemplate: 'null'
  },
  mounted() {
    // Check if cookie already exists from previous session and redirect to dashboard
    if (this.$cookies.get('session_token')) {
      this.$router.push({ path: '/dashboard' });
    }

    // If no cookie exists yet, check if a query string is provided and set cookie before redirecting to dashboard
    if (this.$route.query.token) {
      this.$cookies.set('session_token', this.$route.query.token, '5d');
      this.$router.push({ path: '/dashboard' });
    }

    // If cookie does not exist and no query string is provided send user back to landing page
    if (!this.$route.query.token && !this.$cookies.get('session_token')) {
      this.$router.push({ path: '/' });
    }
  }
}
</script>
